






import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
@Component({
	name:'safetyCheck'
})
export default class SafetyCheck extends AbpBase {
	
}
